import { Chapter, SectionTitle, Reveal } from "./Reveal";
import { IMAGES } from "@/data/content";

const Ambiente = () => (
  <section id="ambiente" data-testid="ambiente-section" className="relative py-24 sm:py-36">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Chapter number="06" title="L'Ambiente" />
      <SectionTitle className="max-w-3xl">
        Un locale piccolo,
        <span className="italic text-[#C5A059]"> in isola pedonale.</span>
      </SectionTitle>

      <div data-testid="ambiente-bento-grid" className="mt-14 grid md:grid-cols-12 gap-5">
        <Reveal className="md:col-span-7">
          <figure className="group relative overflow-hidden h-[320px] sm:h-[440px]">
            <img
              src={IMAGES.sala}
              alt="Sala interna con travi a vista e luci calde"
              loading="lazy"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1.4s] ease-out"
            />
            <figcaption className="absolute inset-x-0 bottom-0 p-6 bg-gradient-to-t from-[#0D0C0B]/90 to-transparent">
              <span className="text-[10px] uppercase tracking-[0.3em] text-[#C5A059]">La Sala</span>
              <p className="mt-2 text-sm text-[#F7F4EE]/90 max-w-md">
                Da ottobre si cena dentro. Pochi tavoli, nessuna tavolata, niente
                voci sopra le voci: è il motivo per cui la sera qui è tranquilla.
              </p>
            </figcaption>
          </figure>
        </Reveal>

        <Reveal delay={0.12} className="md:col-span-5">
          <figure className="group relative overflow-hidden h-[320px] sm:h-[440px]">
            <img
              src={IMAGES.dehors}
              alt="Tavoli all'aperto in estate, in isola pedonale"
              loading="lazy"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1.4s] ease-out"
            />
            <figcaption className="absolute inset-x-0 bottom-0 p-6 bg-gradient-to-t from-[#0D0C0B]/90 to-transparent">
              <span className="text-[10px] uppercase tracking-[0.3em] text-[#C5A059]">I Tavoli Fuori · Estate</span>
              <p className="mt-2 text-sm text-[#F7F4EE]/90 max-w-md">
                In estate i tavoli sono fuori, in mezzo alla passeggiata: niente
                macchine, solo la gente che passa e le bancarelle dell'artigianato.
                Si cena dentro il movimento della città.
              </p>
            </figcaption>
          </figure>
        </Reveal>

        <Reveal delay={0.08} className="md:col-span-5">
          <figure className="group relative overflow-hidden h-[260px] sm:h-[300px]">
            <img
              src={IMAGES.sala2}
              alt="Dettaglio della sala, tavoli apparecchiati"
              loading="lazy"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1.4s] ease-out"
            />
            <figcaption className="absolute bottom-4 left-4 text-[10px] uppercase tracking-[0.3em] text-[#C5A059] bg-[#0D0C0B]/70 backdrop-blur px-3 py-1.5">
              Dettagli
            </figcaption>
          </figure>
        </Reveal>

        <Reveal delay={0.16} className="md:col-span-7">
          <div className="h-[260px] sm:h-[300px] border border-[#C5A059]/25 bg-[#1C1917] p-8 sm:p-10 flex flex-col justify-center">
            <span className="text-[10px] uppercase tracking-[0.3em] text-[#C5A059]">
              Le cene durano
            </span>
            <p className="mt-4 font-display text-lg sm:text-xl text-[#F7F4EE] leading-snug max-w-lg">
              I posti sono pochi: prenota, che nei fine settimana si riempie. Da noi
              nessuno ha fretta e non mandiamo via nessuno. Chi ci ha recensito
              parla di "atmosfera tranquilla e riservata"; un ospite tedesco ha
              scritto che stare in queste stradine italiane è semplicemente da sogno.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Ambiente;
